<template>
    <div>
        <b-button 
            @click="toggleEditMode"
            v-if="!editMode"
            class="edit-button"
        >Добавить реквизиты</b-button>        
        <div v-if="editMode">
            <h5 class="mb-4">Добавление банковских реквизитов</h5>
            <div class="form-row mb-3">
                <div class="form-group col-md-6">
                    <label>Наименование банка</label>
                    <input v-model="editedItem.bank_name" type="text" class="form-control">
                </div>
                <div class="form-group col-md-6">
                    <label>Валюта счета</label>
                    <tsoft-select-of-properties
                        :reference_id="16"
                        :needNullElement="false"
                        :needMultipleSelect="false"
                        :defaultSelectName="`Выберите нужные варианты`"
                        :selectedArray="editedItem.reference_currency_id"
                        @set="setCurrency"
                    ></tsoft-select-of-properties>
                </div>
                <div class="form-group col" v-if="foreignСompany == 1">
                    <label>БИК</label>
                    <input
                        v-model="editedItem.bic"
                        @input="foreignСompany == 1 ? maxCharsLimit(9, 'bic') : ''"
                        type="text"
                        class="form-control"
                    >
                </div>
                <div class="form-group col">
                    <label>Корр. счет</label>
                    <input
                        v-model="editedItem.correspondent_invoice"
                        @input="foreignСompany == 1 ? maxCharsLimit(20, 'correspondent_invoice') : ''"
                        type="text"
                        class="form-control"
                    >
                </div>
                <div class="form-group col" v-if="foreignСompany == 1">
                    <label>Расч. счет</label>
                    <input
                        v-model="editedItem.payment_invoice"
                        @input="foreignСompany == 1 ? maxCharsLimit(20, 'payment_invoice') : ''"
                        type="text"
                        class="form-control"
                    >
                </div>
                <div class="form-group col" v-if="foreignСompany == 0">
                    <label>SWIFT</label>
                    <input v-model="editedItem.swift" type="text" class="form-control">
                </div>
                <div class="form-group col-md-12">
                    <label>Комментарий</label>
                    <textarea v-model="editedItem.comment" type="text" class="form-control" rows="1" placeholder="Введите комментарий..."></textarea>
                </div>
            </div>
            <div class="text-right mb-3">
                <b-button
                    @click="toggleEditMode"
                >Отменить</b-button>  
                <button type="submit" class="btn btn-primary ml-2" @click="createPaymentsDetails">Сохранить</button>
            </div>
        </div>
        <h5>Банковские реквизиты</h5>
        <b-table
            hover
            :responsive="responsive"
            :stacked="stacked"
            show-empty
            :items="items"
            :fields="fields"
            empty-text="Банковские реквизиты компании отсутствуют"
        >
            <template v-slot:cell(actions)="row">
                <div class="text-center" style="min-width: 70px;">
                    <span
                        size="sm"
                        @click="editPaymentItem(row.index)"
                        class="table_actions_edit mx-1"
                    >
                        <i class="fas fa-pencil-alt"></i>
                    </span>
                    <span
                        size="sm"
                        class="table_actions_delete mx-1"
                        @click="deletePaymentItem(row.index)"
                    >
                        <i class="fas fa-trash"></i>
                    </span>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
import {API_PAYMENTS_DETAIL, API_COMPANY} from '../../constants'
import {
    defaultDataItems,
    maxCharsLimit
} from '../../mixins'

const initialEditedItem = () => ({
    company_id: '',
    bic: '',
    bank_name: '',
    correspondent_invoice: '',
    swift: '',
    payment_invoice: '',
    reference_currency_id: '',
    comment: ''
})

export default {
    mixins: [
        defaultDataItems,
        maxCharsLimit
    ],
    props: {
        companyId: { type: Number | String, required: true },
        changeLoad: { type: Boolean, default: false, required: false },
    },
    data () {
        return {
            items: [],
            fields: [
                { key: 'bank_name', label: 'Наим. банка' },
                { key: 'correspondent_invoice', label: 'Корр. счет' },
                { key: 'payment_invoice', label: 'Расч. счет' },
                { key: 'bic', label: 'БИК' },
                { key: 'swift', label: 'SWIFT' },
                { key: 'currency.name', label: 'Валюта', class: 'text-center' },
                { key: 'comment', label: 'Комментарии', class: 'text-center' },
                { key: 'actions', label: 'Действия', class: 'text-center' },
            ],
            apiPaymentsDetail: API_PAYMENTS_DETAIL,
            apiCompany: API_COMPANY,
            foreignСompany: 1,  //selector type company
            editIndex: -1,
            editedItem: {},
            editMode: false
        }
    },
    watch: {
        changeLoad: function(){
            this.editedItem.company_id = this.companyId
            this.showPaymentsDetails()
        }
    },
    computed: {
        stacked() {
            const stackedBreakpoints = ['sm'];
            return stackedBreakpoints.includes(this.$mq);
        },
        responsive() {
            const responsiveBreakpoints = ['md', 'lg', 'xl'];
            return responsiveBreakpoints.includes(this.$mq);
        }
    },
    mounted () {
        this.editedItem = initialEditedItem();
        this.showPaymentsDetails();
    },
    methods: {
        //show paiment item
        showPaymentsDetails() {
            api.call('get', `${this.apiCompany}/${this.companyId}`).then(({data}) => {
                this.items = data.payment_details
                this.foreignСompany = data.in_russia
            })
        },
        //delete payment item
        deletePaymentItem(index) {
            let id = this.items[index].id

            this.$swal({
                title: 'Подтвердите удаление',
                icon: 'question',
                showCancelButton: true,
                cancelButtonText: 'Нет',
                confirmButtonText: 'Да',
            }).then((result) => {
                if(result.isConfirmed){
                    api.call("delete", `${this.apiPaymentsDetail}/${id}`).then(({data}) => {
                        this.items.splice(index, 1)
                    })
                }
            }).finally(() => {
                this.makeToast('danger', 'Банковский реквизит удален')
            })
        },
        //edit payment item
        editPaymentItem(index){
            this.editMode = true;
            this.editIndex = index
            this.editedItem = { ...this.items[index] }
        },
        //create payment item
        createPaymentsDetails() {
            this.editedItem.company_id = this.companyId;

            if(this.editIndex == -1){
                api.call('post', this.apiPaymentsDetail, this.editedItem).then(({data}) => {
                    this.items.unshift(data)
                    this.makeToast('success', 'Банковский реквизит добавлен')
                    this.editedItem = initialEditedItem()
                    this.editedItem.company_id = this.companyId
                    this.editMode = false;
                })
            } else{
                api.call('put', `${this.apiPaymentsDetail}/${this.editedItem.id}`, this.editedItem).then(({data}) => {
                    Object.assign(this.items[this.editIndex], data)
                    this.makeToast('info', 'Банковский реквизит изменен')
                    this.editedItem = {}    //clear item
                    this.editMode = false;
                })
            }

        },
        setCurrency(value) {
            this.editedItem.reference_currency_id = value
        },

        toggleEditMode() {
          this.editMode = !this.editMode;

          if (this.editMode == false) {
            this.editIndex = -1;
            this.editedItem = initialEditedItem();
            this.editedItem.company_id = this.companyId;
          }
        },        
    },
}
</script>
<style scoped>
.edit-button {
    position: absolute;
    top: 12px;
    right: 21px;
}
</style>